import React from "react";
import Home from "./components/Home";
import About from "./components/About";
import Portfolio from "./components/Portfolio";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Home />
      <About />
      <Portfolio />
      <Footer />
    </>
  );
}

export default App;
